<!-- 田地动态 -->
<template>
  <div class="field-dynamics-page">
    <div class="header">
      <p class="cfff text-left top-weather relative">
        <span class="temperature fontBold paddingR6">
          {{ temperature ? temperature + "°" : "" }}
        </span>
        <span class="weather fontBold">{{ weather || "" }}</span>
        <span class="weather-img"><img :src="weatherUrl" alt="" /></span>
      </p>
    </div>
    <div class="map-section">
      <div id="container"></div>
      <div class="map-info flex">
        <div class="left text-left">
          <p class="fontsize-16 c262833 paddingB2">
            {{ farmFieldInfo.farmFieldName }}
          </p>
          <p class="fontsize-12 cC0C1CC">
            {{
              "含" +
              farmFieldInfo.plotAmount +
              "个地块共计" +
              farmFieldInfo.plotArea +
              "亩"
            }}
          </p>
        </div>
        <div class="right cfff text-center" @click="toNavigation">
          <img src="@/assets/images/qiehuan@2x.png" alt="" />
          <span class="fontsize-12">切换田地</span>
        </div>
      </div>
    </div>
    <img
      src="@/assets/images/bi@2x.png"
      alt=""
      v-if="!showPopup"
      class="addimg"
      @click="hanldeAdd"
    />

    <van-popup v-model="showPopup" round position="bottom">
      <van-picker
        title="切换田地"
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="showPopup = false"
      />
      <!-- 弹框 -->
      <div class="add-field text-center" @click="addField">
        <span class="img marginR10">
          <img src="@/assets/images/jiahao@2x.png" alt="" />
        </span>
        <span class="text fontsize-16 cfff">创建田地</span>
      </div>
    </van-popup>
    <!-- 田地图文详情 -->
    <div class="filed-details">
      <div class="step-div">
        <vue-custom-scrollbar
          class="scroll-area"
          :settings="settings"
          @ps-scroll-y="scrollHanle"
        >
          <!-- 内容 -->
          <van-steps direction="vertical" :active="farmingRecordList.length">
            <van-step v-for="(item, index) in farmingRecordList" :key="index">
              <div class="content paddingL10">
                <p class="time-user flex" @click="hanldeClick(item)">
                  <span class="left text-left c262833 fontsize-16">
                    {{ $mUtils.formatDate(item.createdDate) }}
                  </span>
                  <span class="right text-right c91929B fontsize-12">
                    {{ item.farmFieldName }}
                  </span>
                </p>
                <template v-if="item.deletedBy === 2">
                  <p class="weather marginT10 c91929B fontsize-12 text-left">
                    <span class="paddingL10"> 内容违规，已被管理员删除！ </span>
                  </p>
                </template>
                <template v-else>
                  <p
                    class="weather marginT10 c91929B fontsize-12 text-left"
                    @click="hanldeClick(item)"
                  >
                    <span class="paddingL10">
                      天气：{{ item.weather.weather }}
                    </span>
                    <span class="paddingL10 paddingR10">|</span>
                    <span>温度：{{ item.weather.temperature }}℃</span>
                    <span class="paddingL10 paddingR10">|</span>
                    <span>降水：{{ item.weather.precipitation }}mm</span>
                  </p>
                  <p class="text text-left">
                    <span
                      v-if="!item.isView"
                      :class="item.recordText.length > 100 ? 'text-word' : ''"
                      @click="hanldeClick(item)"
                    >
                      {{ item.recordText.substring(0, 100) }}
                    </span>
                    <span v-else @click="hanldeClick(item)">{{
                      item.recordText
                    }}</span>
                    <span
                      class="text-btn fontsize-16 cFF6B4F"
                      v-if="item.recordText.length > 100 && !item.isView"
                      @click="viewAll(index)"
                    >
                      全文
                    </span>
                    <span
                      class="text-btn fontsize-16 cFF6B4F"
                      v-if="item.recordText.length > 100 && item.isView"
                      @click="viewAll(index)"
                    >
                      收起全文
                    </span>
                  </p>
                  <p class="pics flex">
                    <template v-if="item.mediaCoverUrl">
                      <span class="paddingR10 relative spanVideo">
                        <video
                          width="100%"
                          height="100%"
                          ref="videoPlayer"
                          controls
                          webkit-playsinline="true"
                          playsinline="true"
                          x5-video-player-type="h5-page"
                          loop="loop"
                          style="background: black"
                          :id="'video' + index"
                          :poster="item.mediaCoverUrl"
                        >
                          <source :src="item.mediaUrlAlurl" type="video/ogg" />
                          <source :src="item.mediaUrlAlurl" type="video/mp4" />
                          您的浏览器不支持此种视频格式。
                        </video>
                        <!-- <span :id="'videoDefaultImg' + index" class="video-default-img" @click="playVideo(item,index)">
                        <img :src="item.mediaCoverUrl">
                      </span> -->
                        <!-- <img :id="'playBtn' + index" class="play-btn" src="@/assets/images/bofang1@2x.png" alt=""> -->
                      </span>
                    </template>
                    <template v-else>
                      <span
                        v-for="(el, inde) in item.recordPicUrls"
                        :key="inde"
                        class="paddingR10 spanPic"
                      >
                        <img
                          :src="el"
                          alt="预览图片"
                          @click="hanldeImg(item, inde)"
                        />
                      </span>
                    </template>
                  </p>
                </template>
              </div>
            </van-step>
          </van-steps>

          <!--加载更多-->
          <div class="loading-more-box text-center">
            <p class="loading-more" v-if="!hasMore">没有更多数据</p>
            <van-loading size="24px" v-if="hasMore">加载中...</van-loading>
          </div>
        </vue-custom-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import getUserMethods from "utils/getUserMethods";
import { Popup, Picker, Steps, Step, Loading, Toast } from "vant";
import AMapLoader from "@amap/amap-jsapi-loader";
import coordtransform from "coordtransform";
import LoadingMore from "@/components/base/loading-more";
import { mapState } from "vuex";
import vueCustomScrollbar from "vue-custom-scrollbar";
import "vue-custom-scrollbar/dist/vueScrollbar.css";
export default {
  mixins: [getUserMethods], // mixins混入策略
  data() {
    return {
      windowHeight: document.documentElement.clientHeight, // 实时屏幕高度
      api_farmField_info: "/farmField/info", // 田地详情
      api_farmField_list: "/farmField/list", // 田地列表
      api_farmingRecord_list: "/farmingRecord/list", // 农事记录列表
      map: null,
      temperature: "",
      weather: "",
      weatherUrl: "",
      night: 0,
      wtIcon: "",
      farmFieldInfo: {
        plotAmount: 0,
        plotArea: 0,
      },
      farmFieldId: "",
      items: [], // 多边形经纬度数组
      showPopup: false,
      columns: [], // Picker 选择器下拉列表
      farmFieldList: [],
      farmingRecordQuery: {
        page: 1,
        size: 10,
      },
      farmingRecordList: [],
      farmingRecordTotle: 0,
      hasMore: true,
      loading: true,
      total: 0,
      settings: {
        suppressScrollY: false,
        suppressScrollX: false,
        wheelPropagation: false,
      },
      currentLonLat: [], // coordtransform转换高德经纬度后的天地图经纬度
    };
  },
  components: {
    "van-popup": Popup,
    "van-picker": Picker,
    "van-steps": Steps,
    "van-step": Step,
    "van-loading": Loading,
    vueCustomScrollbar,
    LoadingMore,
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    // 浏览器高度
    document.getElementById("container").style.height = 192 + "px";
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      refresh: (state) => state.user.refresh,
      stateFarmFieldId: (state) => state.user.farmFieldId,
      location: (state) => state.user.location,
    }),
  },
  watch: {
    userInfo: {
      handler() {
        this.getFarmFieldList();
      },
      deep: true,
      immediate: true,
    },
    refresh: {
      handler(val) {
        if (val) {
          this.$store.commit("setRefresh", false);
          // app通知我刷新页面
          this.getFarmFieldList();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    scrollHanle(evt) {
      // console.log("滚动到底部");
      if (this.loading) return;
      if (this.total == this.farmingRecordList.length) {
        this.hasMore = false;
        return;
      }
      this.hasMore = true;
      this.farmingRecordQuery.page++;
      this.getFarmingRecordList("more");
    },
    /**
     * 田地详情
     */
    getFarmFieldInfo() {
      this.$store.commit("updateFieldData", {}); //  清空田地数据
      this.$store.commit("farmPlotInfo", null); // 清空所选地块经纬度集合存储
      this.$store.commit("farmPlotArea", null);
      this.farmFieldInfo.plots = [];
      this.items = [];
      this.$axios
        .get(this.api_farmField_info, {
          farmFieldId: this.farmFieldId,
          weather: true,
        })
        .then((res) => {
          // 气象数据未续费出不来兼容处理，确保地块信息能加载
          if (res.data.recordWeather.temperature) {
            this.temperature = res.data.recordWeather.temperature;
            this.weather = res.data.recordWeather.weather;
            this.night = res.data.recordWeather.night;
            this.wtIcon = res.data.recordWeather.wtIcon;
            this.weatherUrl = require(`@/assets/images/weather/${
              this.night ? "n" : "d"
            }/${this.wtIcon}.svg`);
          }
          this.farmFieldInfo = res.data;
          this.farmFieldInfo.plots.forEach((item) => {
            this.items.push(JSON.parse(item.farmPlotInfo));
          });
          //DOM初始化完成进行地图初始化
          this.initMap();
        });
    },
    /**
     * 获取田地列表
     */
    getFarmFieldList() {
      let params = {};
      this.$axios.get(this.api_farmField_list, params).then((res) => {
        this.farmFieldList = res.data.content || [];
        if (this.farmFieldList.length < 1) {
          this.$router.push({ path: "/field-entrance" });
        } else {
          this.columns = [];
          this.farmFieldId = res.data.content[0].farmFieldId;
          this.farmFieldList.forEach((item) => {
            this.columns.push(item.farmFieldName);
            // 初始化田地渲染及切换田地渲染
            if (item.farmFieldId === this.stateFarmFieldId) {
              this.farmFieldId = item.farmFieldId;
            } else {
              this.farmFieldId = this.farmFieldList[0].farmFieldId;
            }
          });
          this.$store.commit("updateFieldId", this.farmFieldId);
          this.getFarmFieldInfo();
          this.getFarmingRecordList();
        }
      });
    },
    /**
     * 地图初始化
     */
    initMap() {
      AMapLoader.load({
        key: "30f8b93a988c168e4e44e5e674dc49b1", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ["AMap.Scale", "AMap.PolygonEditor"], // 需要使用的的插件列表，如比例尺'AMap.Scale',AMap.PolygonEditor多边形编辑器等
      })
        .then((AMap) => {
          // //高德矢量
          // var layer_std = new AMap.TileLayer();
          // //高德路网
          // var layer_dl = new AMap.TileLayer.RoadNet();
          // 转换为天地图矢量和地图确保和画地页面一致
          let key = "29de3ed451c572bc898b208ee7c06880";
          var vecTileLayer = new AMap.TileLayer({
            // 天地图矢量底图图块取图地址
            getTileUrl: `http://t{0,1,2,3,4,5,6,7}.tianditu.gov.cn/DataServer?T=vec_w&tk=${key}&x=[x]&y=[y]&l=[z]`,
            zIndex: 0,
          });
          var cvaTileLayer = new AMap.TileLayer({
            // 天地图矢量注记图块取图地址
            getTileUrl: `http://t{0,1,2,3,4,5,6,7}.tianditu.gov.cn/DataServer?T=cva_w&tk=${key}&x=[x]&y=[y]&l=[z]`,
            zIndex: 2,
          });
          let lon = this.items[0][0][0];
          let lat = this.items[0][0][1];
          this.currentLonLat = coordtransform.gcj02towgs84(lon, lat);
          this.map = new AMap.Map("container", {
            // 设置地图容器id
            // viewMode: "3D", // 是否为3D地图模式
            resizeEnable: true,
            zoom: 15, // 初始化地图级别
            zooms: [3, 20],
            expandZoomRange: true, // 扩大高德地图缩放级别到20
            // layers: [layer_std, layer_dl],
            layers: [vecTileLayer, cvaTileLayer],
            // center: this.items[0][0],
            center: this.currentLonLat, // 初始化地图中心点位置
          });
          // 比例尺
          AMap.plugin("AMap.Scale", () => {
            var scale = new AMap.Scale({
              visible: true,
            });
            this.map.addControl(scale);
          });
          this.map.on("click", this.showMapClick); // 地图点击事件
          // 多边形绘制
          this.items.map((item, index) => {
            // let { fenceid, fence } = item;
            let polygon = new AMap.Polygon({
              map: this.map, // 渲染多边形方案一
              path: item, //设置多边形边界路径
              strokeColor: "#F77A3C", //线颜色
              strokeOpacity: 1, //线透明度
              strokeWeight: 3, //线宽
              fillColor: "#FFFFFF", //填充色
              fillOpacity: 0.4, //填充透明度
            });
            // 多边形点击事件
            polygon.on("click", (e) => {
              // this.showInfoP(e, index);
              this.showMapClick();
            });
          });
          this.map.setFitView(); // 缩放地图到合适的视野级别
          // 首先获取当前地图中所有覆盖物的实例。
          this.mapPolyArr = this.map.getAllOverlays("polygon");
          this.mapPolyArr.forEach((el, Index) => {
            el.Index = Index;
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    /**
     * 地图点击跳转田地详情
     */
    showMapClick() {
      // 第二版跳转前判断一下机型，如果是安卓，则获取一下定位信息
      // if (/(Android)/i.test(navigator.userAgent)) {
      //   if (this.location.lon) {
      //     this.$router.push({
      //       name: "田地详情",
      //       query: { farmFieldId: this.farmFieldId },
      //     }); // 跳转田地详情
      //   } else {
      //     const row = {
      //       type: 14,
      //     };
      //     this.$bridge.callhandler("setAppEvent", JSON.stringify(row));
      //   };
      // }else{
      //   this.$router.push({
      //     name: "田地详情",
      //     query: { farmFieldId: this.farmFieldId },
      //   }); // 跳转田地详情
      // };
      // 第三版
      if(this.location.lon) {
        this.$router.push({
          name: "田地详情",
          query: { farmFieldId: this.farmFieldId },
        }); // 跳转田地详情
      } else {
        const row = {
          type: 14,
        };
        this.$bridge.callhandler("setAppEvent", JSON.stringify(row));
      };
    },
    /**
     * 打开切换田地弹框
     */
    toNavigation() {
      this.showPopup = !this.showPopup;
    },
    /**
     * 切换田地选择
     */
    onConfirm(value) {
      if (this.loading) {
        Toast("加载中");
        return;
      }
      this.farmFieldInfo.farmFieldName = value;
      this.farmFieldList.forEach((item) => {
        if (item.farmFieldName === value) {
          this.farmFieldId = item.farmFieldId;
          this.$store.commit("updateFieldId", this.farmFieldId);
        }
      });
      this.getFarmFieldInfo();
      this.getFarmingRecordList();
      this.showPopup = !this.showPopup;
    },
    //添加按钮触发事件
    addField() {
      // 第一版
      // if (this.location.lon) {
      //   this.$router.push({ path: "/add-field" });
      // } else {
      //   Toast.fail("请先开启手机定位再创建田地");
      // };
      // 第二版 跳转前判断一下机型，如果是安卓，则获取一下定位信息
      // if (/(Android)/i.test(navigator.userAgent)) {
      //   if (this.location.lon) {
      //     this.$router.push({ path: "/add-field" });
      //   } else {
      //     const row = {
      //       type: 14,
      //     };
      //     this.$bridge.callhandler("setAppEvent", JSON.stringify(row));
      //   };
      // }else{
      //   this.$router.push({ path: "/add-field" });
      // };
      // 第三版，安卓和iOS都要处理
      if(this.location.lon) {
        this.$router.push({ path: "/add-field" });
      } else {
        const row = {
          type: 14,
        };
        this.$bridge.callhandler("setAppEvent", JSON.stringify(row));
      };
    },
    //点击进入农事详情
    hanldeClick(item) {
      const row = {
        type: 3,
        recordId: item.recordId,
      };
      this.$bridge.callhandler("setAppEvent", JSON.stringify(row));
    },
    //点击进入新增农事详情
    hanldeAdd() {
      this.$bridge.callhandler("setAppEvent", { type: "5" });
    },
    //点击查看大图
    hanldeImg(item, index) {
      const row = {
        type: 6,
        imgUrls: item.recordPicUrls.join(","),
        clickIndex: index,
      };
      this.$bridge.callhandler("setAppEvent", JSON.stringify(row));
    },
    /**
     * 获取农事记录列表
     */
    getFarmingRecordList() {
      this.loading = true;
      this.$axios
        .get(this.api_farmingRecord_list, {
          ...this.farmingRecordQuery,
          farmFieldId: this.farmFieldId,
        })
        .then((res) => {
          var list = res.data.content.map((v) => {
            if (v.recordPicUrls) {
              v.recordPicUrls = v.recordPicUrls.split(",");
            }
            if (v.recordText.length > 100) v.isView = false;
            else v.isView = true;
            return v;
          });
          if (this.farmingRecordQuery.page == 1) {
            this.farmingRecordList = list;
          } else {
            this.farmingRecordList = [...this.farmingRecordList, ...list];
          }
          this.total = res.data.page.totalElements;
          if (this.total === this.farmingRecordList.length) {
            this.hasMore = false;
          }
          this.loading = false;
          setTimeout(() => {
            this.farmingRecordList.forEach((item, index) => {
              if (item.mediaCoverUrl) {
                this.cutPicture(item, index);
              }
            });
          }, 1000);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //转换第一帧,该方法转第一帧视频背景为黑，先弃用
    cutPicture(item, index) {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        let id = "video" + index;
        let video = document.getElementById(id);
        // video.style = 'position:fixed; top: 9999px;left:9999px;z-index:-9999';
        video.preload = "metadata";
        if (item.mediaUrlAlurl.slice(0, 5) == "https") {
          item.mediaUrlAlurl = item.mediaUrlAlurl; // 直播源
        } else {
          item.mediaUrlAlurl =
            item.mediaUrlAlurl.slice(0, 4) + "s" + item.mediaUrlAlurl.slice(4); // 直播源
        }
        video.src = item.mediaUrlAlurl; // 直播源
        console.log(video.src, "mediaUrlAlur直播源地址");
        video.currentTime = 1; //截取的视频第一秒作为图片
        video.setAttribute("preload", "none");
        //video.setAttribute('autoplay','autoplay')
        video.setAttribute("crossOrigin", "anonymous");
      }
    },
    playVideo(item, index) {
      let videoDefaultImg = "videoDefaultImg" + index;
      let playBtn = "playBtn" + index;
      document.getElementById(videoDefaultImg).style.display = "none"; //隐藏
      document.getElementById(playBtn).style.display = "none"; //隐藏
      this.$refs.videoPlayer.forEach((el, inde) => {
        this.$refs.videoPlayer[inde].play();
      });
    },
    /**
     * 查看全文
     */
    viewAll(index) {
      this.farmingRecordList[index].isView =
        !this.farmingRecordList[index].isView;
    },
  },
};
</script>
<style lang="scss" scoped>
/* @import url(); 引入css类 */
.field-dynamics-page {
  overflow: hidden;

  .scroll-area {
    position: relative;
    margin: auto;
    width: 100%;
    height: 65vh;
    // height: 65vh;
    .ps__rail-y {
      display: none;
    }

    .ps__thumb-y {
      display: none;
      -ms-overflow-style: none;
      overflow: -moz-scrollbars-none;
    }

    ::-webkit-scrollbar {
      display: none;
    }
  }

  .addimg {
    position: fixed;
    bottom: 10%;
    right: 5%;
    z-index: 1000;
    width: 50px;
    height: 50px;
  }

  .header {
    width: 100%;
    height: 160px;
    padding: 26px 15px 15px 27px;
    background: linear-gradient(-30deg, #f87940, #fe7257);
    .top-weather {
      display: flex;
      align-items: center;
      padding-top: 24px;
      .temperature {
        font-size: 50px;
      }
      .weather {
        font-size: 15px;
        padding-top: 20px;
      }
      .weather-img {
        position: absolute;
        display: inline-block;
        width: 36px;
        height: 36px;
        right: 0px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .map-section {
    height: 252px;
    margin: -42px 15px 0px 15px;
    border-radius: 12px !important;
    background: #ffffff;
    #container {
      width: 100%;
      padding: 0px;
      margin: 0px;
      border-radius: 12px !important;
      -webkit-backface-visibility: hidden;
      -webkit-transform: translate3d(0, 0, 0);
    }
    .map-info {
      padding: 11px;

      .left {
        flex: 0.75;
      }

      .right {
        margin-top: 5px;
        flex: 0.25;
        line-height: 35px;
        width: 80px;
        height: 32px;
        background: linear-gradient(90deg, #ff8b57, #ff6b4f);
        box-shadow: 0px 2px 5px 0px rgba(247, 122, 60, 0.2);
        border-radius: 16px;

        img {
          display: inline-block;
          width: 14px;
          height: 12px;
          vertical-align: middle;
          margin-top: -1px;
        }

        span {
          padding-left: 3px;
        }
      }
    }
  }

  .add-field {
    width: 100%;
    height: 45px;
    background: linear-gradient(90deg, #ff8b57, #ff6b4f);
    bottom: 0;
    z-index: 20003;

    .img {
      display: inline-block;
      width: 14px;
      height: 14px;

      img {
        width: 100%;
        height: 100%;
        margin-top: -5px;
      }
    }

    .text {
      line-height: 45px;
    }
  }

  .filed-details {
    background: #ffffff;
    border-radius: 12px;
    margin: 15px;
    // min-height: 500px;
    .step-div {
      padding: 5px;

      .content {
        .time-user {
          .left {
            flex: 0.6;
          }

          .right {
            flex: 0.4;
          }
        }

        .weather {
          background: #f5f8fd;

          span {
            display: inline-block;
            padding-top: 5px;
            padding-bottom: 5px;
          }
        }

        .text {
          padding: 15px 0px 10px 0;

          .text-word {
            /* 文本超出显示成... */
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            /* 设置可显示的行数 */
            -webkit-line-clamp: 6;
            overflow: hidden;
          }

          .text-btn {
            display: block;
            padding-top: 5px;
          }
        }

        .pics {
          width: 98%;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          span[class*="spanVideo"] {
            flex: 1;
            video {
              width: 50vw;
              height: 30vw;
            }
            .video-default-img {
              position: absolute;
              top: 0;
              left: 0;
              width: 50vw;
              height: 30vw;
            }
            img {
              width: 100%;
              height: 100%;
            }
            .play-btn {
              position: relative;
              bottom: 12px;
              right: 2em;
              width: 25px;
              height: 25px;
              z-index: 10;
            }
          }
          span[class*="spanPic"] {
            flex: 1;
            margin-bottom: 5px;
            padding-right: 5px;
            height: 97px;
            width: calc((100% - 10px) / 3);
            min-width: calc(
              (100% - 10px) / 3
            ); // 加入这两个后每个item的宽度就生效了
            max-width: calc(
              (100% - 10px) / 3
            ); // 加入这两个后每个item的宽度就生效了
            &:nth-child(3n) {
              // 去除第3n个的margin-right
              margin-right: 0;
            }
            // video {
            //   width: 50vw;
            //   height: 30vw;
            // }
            // .video-default-img{
            //   position: absolute;
            //   top: 0;
            //   left: 0;
            //   width: 50vw;
            //   height: 30vw;
            // }
            img {
              width: 100%;
              height: 100%;
            }
            // .play-btn{
            //   position: absolute;
            //   bottom: 8px;
            //   right: 16px;
            //   width: 25px;
            //   height: 25px;
            //   z-index: 10;
            // }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
/* 组件全局css类调整 */
.field-dynamics-page {
  .van-popup {
    .van-picker {
      .van-picker__confirm {
        color: #f77a3c;
      }
    }
  }

  .step-div {
    // 步骤条样式设置
    .van-step--finish .van-step__circle {
      background-color: #fe7257;
      width: 16px;
      height: 16px;
    }

    .van-step--finish .van-step__line {
      background-color: #dcdee6;
    }
  }
}
</style>
